import {
  CAR_TYPES,
  DEFAULT_CAR_TYPE,
  FREE_DIRECTION_CITY_IDS,
  FREE_DIRECTION_CAR_TYPE,
  MIDDLE_RATES_STATISTICS_ID,
} from "../constants/averageRates";
import { getSecondLevelDomain } from "./urls";
import getBillingOption from "./getBillingOption";

export const toPointParam = cityId => (cityId != null ? `${cityId}_1` : null);

export const areSimilarPointsMatching = (fromPoint, toPoint, similar) =>
  Boolean(similar) && similar.fromPoint === fromPoint && similar.toPoint === toPoint;

/** preferred, иначе первый доступный в порядке CAR_TYPES */
export const pickAvailableCarType = (availableCarTypes, preferred = DEFAULT_CAR_TYPE) => {
  const available = new Set(availableCarTypes || []);
  if (preferred && available.has(preferred)) {
    return preferred;
  }
  const next = CAR_TYPES.find(item => available.has(item.value));
  return next ? next.value : null;
};

export const isFreeDirection = ({ fromCityId, toCityId, carType }) => {
  if (fromCityId == null || toCityId == null) return false;

  const [freeFromCityId, freeToCityId] = FREE_DIRECTION_CITY_IDS;
  return (
    fromCityId === freeFromCityId &&
    toCityId === freeToCityId &&
    carType === FREE_DIRECTION_CAR_TYPE
  );
};

export const hasThroughPoints = routeRequest => {
  if (!routeRequest?.through?.length) return false;
  return routeRequest.through.some(point => point && !point.isEmpty());
};

export const buildBillingUrl = ({ hasPayedServices }) => {
  const domain = getSecondLevelDomain();
  const option = getBillingOption(hasPayedServices);
  return `https://billing.${domain}/addinvoice?option=${option}&services=${MIDDLE_RATES_STATISTICS_ID}&priceperiod=1&utm_content=avgprice_rr`;
};

export const buildAnalyticsUrl = ({ fromPoint, toPoint, carType, tonnage = 5 } = {}) => {
  const domain = getSecondLevelDomain();
  const params = new URLSearchParams({
    utm_source: "avgprice_rr",
  });

  if (fromPoint) params.set("from_point", fromPoint);
  if (toPoint) params.set("to_point", toPoint);
  if (carType) params.set("car_types", carType);
  if (tonnage != null) params.set("tonnage", String(tonnage));

  return `https://${domain}/analytics/price?${params.toString()}`;
};

const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

/** Фейковые ставки для paywall без запроса last-rates */
export const generateFakeRates = () => {
  const averagePrice = randomInt(45000, 130000);
  const delta = randomInt(8000, 25000);

  return {
    averagePrice,
    minPrice: Math.max(0, averagePrice - delta),
    maxPrice: averagePrice + delta,
  };
};
